/* Much Elegance — rappel, ouverture manuelle et arrêt après inscription.
   Pas de données personnelles enregistrées côté navigateur. */
(function () {
  function updateClaimedState() {
    try {
      var isSuccess = new URLSearchParams(window.location.search).get('customer_posted') === 'true' &&
        !!document.querySelector('#me-email-popup .me-email-message-success');
      if (isSuccess) localStorage.setItem('me_welcome_claimed', 'true');
      if (localStorage.getItem('me_welcome_claimed') === 'true') {
        document.documentElement.classList.add('me-welcome-claimed');
      }
    } catch (error) {}
  }

  function init() {
    updateClaimedState();
    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-me-welcome-open]');
      if (!button) return;
      if (typeof window.MEOpenPopup === 'function') {
        window.MEOpenPopup(true);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
